export enum FileUploadStatuses {
  AwaitingUpload = 'AwaitingUpload',
  Validating = 'Validating',
  Accepted = 'Accepted',
  Rejected = 'Rejected'
}
